export const RBAC_ACTIONS = ["view", "create", "edit", "delete", "approve", "assign", "configure", "export"];

export const RBAC_MODULES = [
  ["dashboard", "Dashboard"],
  ["revenue", "Revenue"],
  ["applications", "Applications"],
  ["subscriptions", "Subscriptions"],
  ["societies", "Societies"],
  ["users_access", "Users & Access"],
  ["crm_leads", "CRM Leads"],
  ["crm_followups", "CRM Follow-ups"],
  ["crm_meetings", "CRM Meetings"],
  ["vendors", "Vendors"],
  ["experts", "Experts"],
  ["requirements", "Requirements"],
  ["services", "Service Master"],
  ["revenue_configuration", "Revenue Configuration"],
  ["company_accounting", "Company Accounting"],
  ["company_receipts", "Company Receipts"],
  ["company_payments", "Company Payments"],
  ["financial_reports", "Financial Reports"],
  ["accounting_settings", "Accounting Settings"],
  ["commercial_dashboard", "Commercial Dashboard"],
  ["pricing", "Pricing"],
  ["discounts", "Discounts"],
  ["waivers", "Waivers"],
  ["collections", "Collections"],
  ["commercial_reports", "Commercial Reports"],
  ["renewals", "Renewals"],
  ["monetization", "Monetization"],
  ["knowledge", "Knowledge & SEO"],
  ["audit_logs", "Audit Logs"],
  ["staff", "Staff"],
  ["departments", "Departments"],
  ["roles", "Roles & Permissions"],
];

export const RBAC_SCOPES = [
  ["ALL", "All platform data"],
  ["DEPARTMENT", "Department data"],
  ["ASSIGNED", "Assigned records"],
  ["OWN", "Own records"],
];

export const blankPermissions = () => Object.fromEntries(
  RBAC_MODULES.map(([key]) => [
    key,
    Object.fromEntries(RBAC_ACTIONS.map((action) => [action, false])),
  ]),
);

export const permissionCount = (permissions = {}) => Object.values(permissions)
  .reduce((total, actions) => total + Object.values(actions || {}).filter(Boolean).length, 0);